"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Recipients/CsvImportDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactdropzone = require('react-dropzone'); var _reactdropzone2 = _interopRequireDefault(_reactdropzone);



var _supportUrls = require('shared/data/supportUrls');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _format = require('web/screens/Broadcast/format');
var _uploadStandaloneFile = require('web/services/uploadStandaloneFile');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _Spinner = require('web/components/Spinner');
var _helpers = require('../helpers');
var _importDraft = require('../importDraft');
var _isCsvFileName = require('./isCsvFileName');
var _columnStatus = require('./columnStatus');
var _MappingTable = require('./MappingTable'); var _MappingTable2 = _interopRequireDefault(_MappingTable);

const PREVIEW_DELAY_MS = 400

/* A file as an import reads it: its columns, the mapping used (the request's,
 * or the suggested one) and how many data rows it has. */








































































/* Rev 31 v2 · 4, D-98: choose a CSV, map its columns, then the source's own
 * steps (the broadcast's review and Add; the Directory's review and
 * options). Mapping the same file again keeps those steps' state. */
const CsvImportDialog = ({ isOpen, source, onClose, renderSteps }) => {
  const dropzoneRef = _react.useRef(null)
  const [step, setStep] = _react.useState('choose')
  const [chosen, setChosen] = _react.useState(null)
  const [reading, setReading] = _react.useState(null)
  const [error, setError] = _react.useState(null)
  const [isPreviewing, setIsPreviewing] = _react.useState.call(void 0, false)
  // The mapping whose check failed; statuses stay marked until it changes.
  const [failedMapping, setFailedMapping] = _react.useState(null)
  // What the steps after mapping were given, kept while they're left.
  const [mapped, setMapped] = _react.useState(null)
  // The steps after mapping start fresh (a new key) for each mapped file.
  const [mappedVersion, setMappedVersion] = _react.useState.call(void 0, 0)
  const [isBusy, setBusy] = _react.useState.call(void 0, false)

  _react.useEffect.call(void 0, 
    () => {
      if (isOpen) return
      setStep('choose')
      setChosen(null)
      setReading(null)
      setError(null)
      setIsPreviewing(false)
      setFailedMapping(null)
      setIsPickerWanted(false)
      setMapped(null)
      setBusy(false)
    },
    [isOpen],
  )

  const { preview } = source
  const onDropAccepted = ([file]) => {
    if (!file) return
    // A new file replaces the one chosen before, even if it can't be read
    // or isn't a CSV (review F-9).
    setChosen(null)
    setMapped(null)
    if (!_isCsvFileName.isCsvFileName.call(void 0, file.name)) {
      setError(_react2.default.createElement(_react2.default.Fragment, null, "Couldn't read "  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 138}},  file.name ), ". Please choose a .csv file"     ,  source.csvHint ? ` ${source.csvHint}` : '' , "."))
      return
    }
    setError(null)
    setReading(file.name)
    _uploadStandaloneFile.uploadStandaloneFile.call(void 0, file)
      .then(({ FileKey }) => preview(FileKey)
        .then(summary => {
          setChosen({
            fileName: file.name,
            fileSize: file.size,
            fileKey: FileKey,
            summary,
            mapping: summary.Mapping,
            previewedMapping: summary.Mapping,
          })
        }))
      .catch((e) => setError(source.readError
        ? source.readError(file.name, e)
        : _helpers.errorText.call(void 0, e, `Couldn't read ${file.name}`)))
      .finally(() => setReading(null))
  }
  const onOpenFilePicker = () => { if (!reading) _optionalChain([dropzoneRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.open, 'call', _3 => _3()]) }

  // Replace file goes back to Choose file and opens the picker there.
  const [isPickerWanted, setIsPickerWanted] = _react.useState.call(void 0, false)
  _react.useEffect.call(void 0, 
    () => {
      if (step !== 'choose' || !isPickerWanted) return
      setIsPickerWanted(false)
      _optionalChain([dropzoneRef, 'access', _4 => _4.current, 'optionalAccess', _5 => _5.open, 'call', _6 => _6()])
    },
    [step, isPickerWanted],
  )
  const onReplaceFile = () => {
    setStep('choose')
    setIsPickerWanted(true)
  }

  const mapping = _optionalChain([chosen, 'optionalAccess', _7 => _7.mapping])
  const fileKey = _optionalChain([chosen, 'optionalAccess', _8 => _8.fileKey])
  const columns = _optionalChain([chosen, 'optionalAccess', _9 => _9.summary, 'access', _10 => _10.Columns])
  const errors = _react.useMemo.call(void 0, 
    () => columns && mapping ? _importDraft.mappingErrors.call(void 0, columns, mapping) : [],
    [columns, mapping],
  )
  const hasErrors = errors.length > 0

  // The statuses follow the mapping: re-run the preview shortly after a change.
  const isChecked = _optionalChain([chosen, 'optionalAccess', _11 => _11.previewedMapping]) === mapping
  _react.useEffect.call(void 0, 
    () => {
      if (!fileKey || !mapping || hasErrors || isChecked) return
      let isCurrent = true
      setIsPreviewing(true)
      const timer = setTimeout(
        () => preview(fileKey, mapping)
          .then(summary => {
            if (!isCurrent) return
            setChosen(c => c && c.fileKey === fileKey && c.mapping === mapping
              ? { ...c, summary, previewedMapping: mapping }
              : c)
          })
          .catch((e) => {
            if (!isCurrent) return
            setError(_helpers.errorText.call(void 0, e, "Couldn't check the file"))
            setFailedMapping(mapping)
          })
          .finally(() => { if (isCurrent) setIsPreviewing(false) }),
        PREVIEW_DELAY_MS,
      )
      return () => {
        isCurrent = false
        clearTimeout(timer)
      }
    },
    [preview, fileKey, mapping, hasErrors, isChecked],
  )

  const isPreviewCurrent = !!chosen && isChecked
  // Statuses are for the mapping the summary was computed for, never a mix
  // of the edited mapping and an older summary (review R800-11).
  const statuses = _react.useMemo.call(void 0, 
    () => chosen
      ? _columnStatus.columnStatuses.call(void 0, { mapping: chosen.previewedMapping, columns: chosen.summary.Columns, declared: source.declared })
      : [],
    [chosen, source.declared],
  )
  const check = isPreviewCurrent ? 'current'
    : hasErrors || (!!failedMapping && failedMapping === mapping) ? 'failed'
      : 'checking'

  const stepLabel = (n, name) => `Step ${n} of ${source.stepCount} · ${name}`

  const onNext = () => {
    if (!chosen) return
    setError(null)
    // The steps after mapping start again from the file when the mapping changed.
    if (!mapped || mapped.fileKey !== chosen.fileKey || mapped.mapping !== chosen.mapping) {
      setMapped({
        fileName: chosen.fileName,
        fileSize: chosen.fileSize,
        fileKey: chosen.fileKey,
        columns: chosen.summary.Columns,
        mapping: chosen.mapping,
      })
      setMappedVersion(v => v + 1)
    }
    setStep('after')
  }

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      title: source.title,
      className: _classBuilder2.default.call(void 0, 'broadcast-upload-dialog', source.className),
      bodyClassName: "broadcast-upload-dialog--body",
      // An Add or import being sent finishes here: no ×, Esc or backdrop close (R800-54).
      onClose: isBusy ? undefined : onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}}

      ,  step === 'map' && _react2.default.createElement('p', { className: "broadcast-csv-review--step", __self: this, __source: {fileName: _jsxFileName, lineNumber: 258}},  stepLabel(1, 'Map columns') ) 
      ,  step === 'choose' && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('div', {
            role: "button",
            tabIndex: 0,
            'aria-label': "Choose a CSV file"   ,
            onClick: onOpenFilePicker,
            onKeyDown: e => { if (e.key === 'Enter' || e.key === ' ') onOpenFilePicker() },
            className: _classBuilder2.default.call(void 0, 
              'campaign--add-patients--dropzone-area',
              'broadcast-upload-dialog--dropzone',
              !!chosen && 'broadcast-upload-dialog--dropzone--filled',
              !!error && 'campaign--add-patients--dropzone-area--error',
              !!reading && 'campaign--add-patients--dropzone-area--disabled',
            ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 261}}

            , _react2.default.createElement(_reactdropzone2.default, {
              className: "campaign--add-patients--dropzone",
              onDropAccepted: onDropAccepted,
              disabled: !!reading,
              ref: dropzoneRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}}
            )
            , _react2.default.createElement('span', { className: "campaign--add-patients--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 281}}
              ,  reading
                ? _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_Spinner.SimpleSpinner, { className: "campaign--add-patients--label--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 283}} ), "Reading " ,  reading , "…")
                : error
                  ? _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 285}},  error )
                  : chosen
                    ? (
                        _react2.default.createElement('span', { className: "broadcast-recipients--file", __self: this, __source: {fileName: _jsxFileName, lineNumber: 288}}
                          , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 289}},  chosen.fileName )
                          , _react2.default.createElement('span', { className: "broadcast-recipients--file-meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}
                            ,  _format.pluralize.call(void 0, chosen.summary.Rows, 'row', 'rows') , " ·" , ' '
                            ,  _format.pluralize.call(void 0, chosen.summary.Headers.length, 'column', 'columns') , " ·" , ' '
                            ,  _importDraft.formatFileSize.call(void 0, chosen.fileSize) 
                          )
                          , _react2.default.createElement('span', { className: "campaign--add-patients--label--highlight", __self: this, __source: {fileName: _jsxFileName, lineNumber: 295}}, "Choose a different file"   )
                        )
                      )
                    : (
                        _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 299}}, "Click to "
                            , _react2.default.createElement('span', { className: "campaign--add-patients--label--highlight", __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}}, "choose a CSV file"   ), " or drag it here."

                        )
                      )
              
            )
          )
          ,  source.guide 
          , _react2.default.createElement('p', { className: "broadcast-wizard--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 308}}, "For how to structure your file,"
                 , ' '
            , _react2.default.createElement('a', { href: _supportUrls.broadcastSupportUrl, target: "_blank", rel: "noreferrer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}}, "check our guide"  ), "."
          )
          , _react2.default.createElement('div', { className: "broadcast-upload-dialog--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 312}}
            , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 313}}, "Cancel")
            , _react2.default.createElement(_Form.Button, { isDisabled: !chosen || !!reading, onClick: () => setStep('map'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 314}}, "Continue")
          )
        )
      )

      ,  step === 'map' && chosen && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('div', { className: "broadcast-upload-dialog--filebar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 321}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 322}},  chosen.fileName )
            , _react2.default.createElement('span', { className: "broadcast-csv-review--meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 323}}
              ,  _format.pluralize.call(void 0, chosen.summary.Rows, 'row', 'rows') , " ·" , ' '
              ,  _format.pluralize.call(void 0, chosen.summary.Columns.length, 'column', 'columns') 
            )
            , _react2.default.createElement('button', { type: "button", className: "broadcast-mapping--link", onClick: onReplaceFile, __self: this, __source: {fileName: _jsxFileName, lineNumber: 327}}, "Replace file" )
          )
          , _react2.default.createElement('div', { className: "broadcast-upload-dialog--map", __self: this, __source: {fileName: _jsxFileName, lineNumber: 329}}
            , _react2.default.createElement(_MappingTable2.default, {
              columns: chosen.summary.Columns,
              mapping: chosen.mapping,
              previewedMapping: chosen.previewedMapping,
              statuses: statuses,
              check: check,
              allowVariables: source.allowVariables,
              onChange: next => {
                setError(null)
                setChosen({ ...chosen, mapping: next })
              }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 330}}
            )
          )
          ,  error && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 343}},  error ) 
          , _react2.default.createElement('div', { className: "broadcast-upload-dialog--foot broadcast-upload-dialog--foot--sticky" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 344}}
            ,  hasErrors
              ? (
                  _react2.default.createElement('div', { role: "alert", className: "broadcast-upload-dialog--blocked", __self: this, __source: {fileName: _jsxFileName, lineNumber: 347}}
                    ,  errors.map(e => _react2.default.createElement('div', { key: e, __self: this, __source: {fileName: _jsxFileName, lineNumber: 348}},  e )) 
                  )
                )
              : (
                  _react2.default.createElement('span', { className: "broadcast-csv-review--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 352}}
                    ,  source.allowVariables ? 'Name and a phone or email are needed for each row' : 'Name and a phone, email or MRN are needed for each row' 
                  )
                )
            
            , _react2.default.createElement('span', { className: "broadcast-upload-dialog--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 357}} )
            , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 358}}, "Cancel")
            , _react2.default.createElement(_Form.Button, { isDisabled: hasErrors || isPreviewing || !isPreviewCurrent, onClick: onNext, __self: this, __source: {fileName: _jsxFileName, lineNumber: 359}}, "Next: review rows"

            )
          )
        )
      )

      ,  mapped && (
        _react2.default.createElement(_react2.default.Fragment, { key: mappedVersion, __self: this, __source: {fileName: _jsxFileName, lineNumber: 367}}
          ,  renderSteps({
            file: mapped,
            isActive: step === 'after',
            stepLabel,
            onBack: () => setStep('map'),
            onClose,
            setBusy,
          })
        )
      )
    )
  )
}

exports. default = CsvImportDialog
